module.exports = __webpack_public_path__ + "static/media/girl-3.070b1238.svg";